import React from 'react'
import templatePrivatePage from '../Templates/PrivatePage'
import { withAuthorization } from '../../../services/sessions'
import { getPlanningDetail} from '../../../api/plannings'
import { message } from 'antd'
import * as routes from '../../../constants/routes'
import { Redirect } from 'react-router-dom'
import { createPlanningTracking } from '../../../tools/Segment'
import { PageHeader } from '../../Content/Layout/Headers'
import MealCounter from '../../Content/Plannings/MealCounter'
import { MenuToolbar, MainToolbar } from '../../Content/Layout/Toolbar'
import MealsList from '../../Content/Meals/MealsList'

const condition = auth => !!auth

class PlanningLunchesContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            planning: null,
        }
    }

    async componentDidMount() {
        // TODO : handle the case when the planning id is unknown, and the api returned a
        // 404 HTTP message
        this.setState({ isLoading: true, });
        this.props.onLoading();
        // retrieve the information about the planning
        // update the state with the new object    
        try {
            let planningFromApi = await getPlanningDetail(this.props.match.params.id);
            // console.log("Planning récupéré : ",planningFromApi);
            this.setState({
                planning: planningFromApi,
            }, () => {
                if( this.state.planning.lunches.length !== 0 ) {
                    let {
                        label
                    } = this.state.planning;
    
                    this.props.setPageTitle(label);
                    this.props.setBackpage(routes.ORGA_HOME)

                    let pageTracking = createPlanningTracking('Menu / Mes déjeuners', this.state.planning);

                    this.props.trackPage(this.props.user, pageTracking);
                }
            });
        } catch(err) {
            console.log("Erreur lors de la récupération du planning", err);
            message.error("Une erreur s'est produite lors de la récupération de ton planning. Merci de bien vouloir réessayer.");
        }
        this.props.onLoaded();
    }

    render() {
        let { planning } = this.state;

        if( !planning ) {
            return(
                <div>Chargement du menu...</div>
            )
        } else {
            let { lunches, id } = planning;

            if( !lunches || lunches.length === 0 ) {
                return(
                    <Redirect to={routes.PLANNING_LUNCHES_CHOICE(id)} />
                );
            } else {
                return(
                    <div id="menu" className="menu-lunches">
                        <MenuToolbar list planningId={id} />
                        <MealCounter planning={planning} />
                        <PageHeader label="Tes déjeuners" />
                        <MealsList meals={lunches} />
                    </div>
                )
            }
        }
    }
}

const PlanningLunches = templatePrivatePage(PlanningLunchesContent, "", null, MainToolbar)

export default withAuthorization(condition)(PlanningLunches)